import { captureException } from '@sentry/browser';

const reportedErrors = new WeakSet<Error>();

/**
 * Reports an error from the easyclaim.app module (experimental performance enhancer)
 * to Sentry, tagged so it can be filtered/triaged separately from the rest of the app.
 * Relies on `Sentry.init` having already run (see `SentryService`, initialized once
 * during app bootstrap in `src/index.tsx`) — this only attaches scope and captures.
 */
export function reportError(error: unknown, extra?: Record<string, unknown>): void {
	const capturedError = error instanceof Error ? error : new Error(String(error));

	reportedErrors.add(capturedError);
	captureException(capturedError, {
		tags: { module: 'easyclaim.app' },
		extra,
	});
}

export function isErrorReported(error: unknown): boolean {
	return error instanceof Error && reportedErrors.has(error);
}

/** True for `AbortError`s raised when a `fetch`/query is cancelled — expected, not a real failure. */
export function isAbortError(error: unknown): boolean {
	return error instanceof DOMException && error.name === 'AbortError';
}
